<template>
<!-- 账号信用页面 -->
  <div class="dss">
    <el-main>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="账号信用" name="first">
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <ul>
                  <li>当前信用分</li>
                </ul>
                <span v-popover:popover2>信用分说明</span>
                <el-popover ref="popover2" placement="bottom" title="信用分说明" width="200" trigger="click" content="帐号信用分包含扣分机制、惩罚机制、恢复机制、申诉机制四个维度">
                </el-popover>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="progess">
                <br /><br />
                <el-progress :width="180" type="circle" :percentage="percentage"></el-progress>
                <span class="state_date">0分时账号停封</span>
              </div>
              <div style="width: 99%;border-bottom:1px solid #ccc;margin: 30px 0;"></div>
            </el-col>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <ul>
                  <li>信用记录</li>
                </ul>
                <span>点此反馈</span>
              </div>
              <el-table :data="tableData2" style="width: 100%" :row-class-name="tableRowClassName">
                <el-table-column prop="date" label="日期">
                </el-table-column>
                <el-table-column prop="type" label="类型">
                </el-table-column>
                <el-table-column prop="sjwz" label="涉及文章">
                </el-table-column>
                <el-table-column prop="fsbh" label="分数变化">
                </el-table-column>
                <!--<el-table-column prop="fsbh" label="分数变化" filter-placement="bottom-end">
                                                <template slot-scope="scope">
                                                    <a href="javascript:(0)">{{scope.row.fsbh}}</a>
                                                </template>
                                            </el-table-column>-->
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </div>
</template>

<script>
  import { creditScore } from '@/api/api' // 信用分
  import { creditScoreLogs } from '@/api/api'//信用分记录
  export default {
    metaInfo(){
     return{
        title: '账号信用',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
    name: 'dds',
    data() {
      return {
        msg: 'dds页面',
        activeName: 'first',
        percentage: 0,
        credit_score:100,
        tableData2: []
      }

    },
    methods: {
      handleClick(tab, event) {
        ////console.log(tab, event);
      },
      tableRowClassName({ row, rowIndex }) {

      },
      creditScore:function (e) {
        ////console.log(this.content_type)
        creditScore({content_type:this.content_type,status:this.status,page:this.page,limit:this.limit}).then(res=>{
          ////console.log(res);
          this.credit_score = res.data.data.credit_score;
        }).catch(res=>{
          ////console.log("文章列表获取失败");
        })
      },
      //creditScoreLogs
      GetcreditScoreLogs:function (e) {
        creditScoreLogs({content_type:this.content_type,status:this.status,page:this.page,limit:this.limit}).then(res=>{
          ////console.log(res)
          this.tableData2 = res.data.data.data;
        }).catch(res=>{
          ////console.log("文章列表获取失败");
        })
      },

      changeProgress:function () {
        document.querySelector('.el-progress__text').innerHTML = '<span style="color:#2397ee;font-size:0.8em;">信用分</span><br/><span style="color:#2397ee;font-weight:bold;font-size:1.2em">'+this.credit_score+'</span>'
      }
    },
    mounted() {
      let that = this;
      // let timer = setInterval(function() {
      // 	if(that.percentage < 100) {
      // 		that.percentage++;
      // 		document.querySelector('.el-progress__text').innerHTML = '<span style="color:#2397ee;font-size:0.8em;">信用分</span><br/><span style="color:#2397ee;font-weight:bold;font-size:1.2em">' + that.percentage + '</span>'
      // 	} else {
      // 		clearInterval(timer);
      // 	}
      // }, 1000)
      this.creditScore();
      this.changeProgress();
      this.GetcreditScoreLogs();

    },
    watch: {
      //观察option的变化
      credit_score: {
        handler(newVal, oldVal) {
          this.changeProgress();
        },
        deep: true //对象内部属性的监听，关键。
      }
    },
    components: {
   
    }
  }
</script>

<style scoped>
  .el-header,
  .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    width:940px;
    vertical-align: top;
    display: inline-block;
    background: #FFF;
  }

  body>.el-container {
    margin-bottom: 40px;
  }

  .el-container .el-container {
    width: 940px;
    margin: 0 auto;
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background:#fff;
    position: relative;
  }

  .bg-purple-dark ul {
    display: inline-block;
  }

  .bg-purple-dark ul li {
    font-size: 1em;
  }

  .bg-purple-dark span {
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 0.1rem;
    cursor: pointer;
    color: #2397ee;
  }

  .progess {
    width: 100%;
    height: 300px;
    text-align: center;
  }

  .progess span {
    display: block;
    font-size: 0.8em;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  /* .el-table td .cell, */
  .el-table td div{
    text-align: center!important;
  }

  .el-table tr td:nth-of-type(3) div {
    color: #2397ee;
    cursor: pointer;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .state_date{
    margin-top:15px;
  }
</style>
